/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Creem_Signing_SecretInputs */

const en_admin_settings_fields_creem_signing_secret = /** @type {(inputs: Admin_Settings_Fields_Creem_Signing_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing Secret`)
};

/**
* | output |
* | --- |
* | "Signing Secret" |
*
* @param {Admin_Settings_Fields_Creem_Signing_SecretInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_creem_signing_secret = /** @type {((inputs?: Admin_Settings_Fields_Creem_Signing_SecretInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Creem_Signing_SecretInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_creem_signing_secret(inputs)
});
export { admin_settings_fields_creem_signing_secret as "admin.settings.fields.creem_signing_secret" }